import { FC, useEffect } from 'react';

import { breakpoints } from '@/utils/mediaQueries';

import { labelTables } from './labelTables';
import { MobileTablesStyles } from './MobileTables.styled';

const PHONE_QUERY = `(max-width: ${breakpoints.sm - 1}px)`;

interface MobileTablesProps {
  /** Id kontenera treści strony; tylko tabele w nim zamieniają się w listy. */
  containerId: string;
}

/** Na telefonie tabele w treści strony wyświetlają się jako lista kart, bez przewijania w bok. */
export const MobileTables: FC<MobileTablesProps> = ({ containerId }) => {
  useEffect(() => {
    const root = document.getElementById(containerId);
    if (!root || typeof window.matchMedia !== 'function') return undefined;

    const query = window.matchMedia(PHONE_QUERY);
    let frame = 0;
    const schedule = (): void => {
      if (!query.matches || frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        labelTables(root);
      });
    };

    // Obserwujemy tylko zmiany drzewa i tekstu; własne zapisy atrybutów nie wywołują pętli.
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    query.addEventListener('change', schedule);
    schedule();

    return () => {
      observer.disconnect();
      query.removeEventListener('change', schedule);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [containerId]);

  return <MobileTablesStyles $containerId={containerId} />;
};
